import React from "react";

export default function Error() {
  return (
    <div className="text-3xl font-bold dark:text-light-text text-red-stroke">
      404 Not Found
    </div>
  );
}
